import React, { useState } from "react";
import { BiMinusCircle, BiPlusCircle } from 'react-icons/bi'
import { Input } from "../../../../../../generics/input-group";
import { InputBlock } from "./components/input-block";

export const ContraProposta = () => {
  const [show, setShow] = useState(false)
  return (
    <div className={`mb-4 rounded-md bg-white `}>
      <div className="flex w-full flex-col rounded-md border border-gray-400 pr-2">
        <div className="w-full py-2 px-4 flex items-center text-sm  justify-between">
          <p className="font-medium text-xs text-gray-600">Contrato: 12345678909</p>

          <button type="button" onClick={() => setShow(!show)}>
            {
              show ?
                <BiMinusCircle size={24} className="fill-primary" /> : <BiPlusCircle size={24} className="fill-primary" />
            }
          </button>
        </div>
        <div className={`${!show && "hidden"} flex flex-col w-full px-4 `}>
          <p className="w-full text-center my-2">Dados da proposta</p>
          {/* Inputs Acionador */}
          <div className="border rounded-md  border-gray-400 px-2">
            <div className="flex items-center gap-2 w-full my-2" >
              <InputBlock name="CPF/CNPJ"
                isLocked width="w-[70%]" placeholder="881.399.302-10" />
              <InputBlock name="Nome" isLocked placeholder="RENATO DA SILVA CAMPOS" />
              <InputBlock name="Documento" placeholder="88139930210" />
            </div>
            <div className="flex items-center gap-2 w-full my-2" >
              <InputBlock name="Data" width="w-[40%]" placeholder="08/11/2023" />
              <InputBlock name="Hora" width="w-[30%]" placeholder="12:47" />
              <InputBlock name="Origem" placeholder="PORTAL" />

            </div>

          </div>

          {/* Inputs de Negociador */}
          <div className="border rounded-md  border-gray-400 px-2 my-2">
            <p className="w-full text-center my-2">Proposta</p>

            <div className="flex items-center gap-2 w-full my-2" >
              <InputBlock name="Tipo Proposta" placeholder="AV" width="w-[30%]" isLocked />
              <InputBlock name="Forma de Pagamento" placeholder="Pix" width="w-[30%]" isLocked />

              <InputBlock name="Melhor Data de Pagamento" width="w-[40%]" placeholder="20/11/2023" isLocked />
            </div>
            <div className="flex items-center gap-2 w-full my-2" >
              <InputBlock name="Valor Débito" isLocked width="w-[40%]" placeholder="R$ 5.456,90" />
              <InputBlock name="Proposta Ofertada" width="w-[40%]" placeholder="R$ 2.000,00" isLocked />
              <InputBlock name="Contra Proposta" width="w-[40%]" placeholder="R$ 1.500,00" isLocked />
              {/* <InputBlock name="Total" width="w-[30%]" placeholder="R$ 1.500,00" /> */}

            </div>
            {/* <div className="flex items-center gap-2 w-full my-2" >
              <InputBlock name="Entrada" width="w-[20%]" placeholder="R$ 1.034,90" />
              <InputBlock name="Data Entrada" width="w-[20%]" placeholder="20/11/2023" />
              <InputBlock name="Valor Parcela" width="w-[20%]" placeholder="0" />
              <InputBlock name="Qtd Parcelas" width="w-[20%]" placeholder="0" />
              <InputBlock name="Total" width="w-[30%]" placeholder="R$ 5.456,90" />
            </div> */}

            <div className="flex items-center gap-2 w-full my-2" >
              <InputBlock name="Desc. Ofertado" width="w-[20%]" placeholder="63%" isLocked />
              <InputBlock name="Desc. Contra Proposta" width="w-[20%]" placeholder="73%" isLocked />

            </div>

          </div>

          <div className="border rounded-md  border-gray-400 px-2 my-2 py-2">

            <p className="text-sm font-medium text-gray-500">Motivo</p>
            <textarea className=" block h-[40%] w-full resize-none rounded-md border border-gray-300 bg-gray-100 px-2.5 py-1.5 text-sm text-gray-500 outline-none" placeholder="Infelizmente, devido à minha atual situação financeira, vou conseguir pagar apenas o valor proposto." disabled></textarea>

          </div>


        </div>
      </div>
    </div>
  )
}